/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

/* Reducers are defined and combined here */
import { loginReducer, logoutReducer } from './authReducer';
import peopleReducer from './peopleReducer';
import studyReducer from './studyReducer';
import participantReducer from './participantReducer';
import noteReducer from './noteReducer';
import modalReducer from './modalReducer';
import sponsorReducer from './sponsorReducer';
import documentsReducer from './documentsReducer';
import documentStatusReducer from './documentStatusReducer';
import subjectReducer from './subjectReducer';
import newNoteReducer from './newNoteReducer';
import assignmentsReducer from './assignmentsReducer';
import participantDetailsReducer from './participantDetailsReducer';
import helpdeskReducer from './helpdeskReducer';
import rolesReducer from './rolesReducer';
import consentingJournalReducer from './consentingJournalReducer';
import monitorsReducer from './monitorsReducer';
import participantStatusReducer from './participantStatusReducer';
import organizationsReducer from './organizationsReducer';
import reportsReducer from './reportsReducer';
import menuReducer from './menuReducer';
import delegationLogReducer from './delegationLogReducer';
import pdfReducer from './pdfReducer';
import peopleDetailsReducer from './peopleDetailsReducer';
import qlikReportsReducer from './qlikReportsReducer';
import documentStatusSoP from './documentStatusSoP';
import changeAnswersReducer from './changeAnswersReducer';
import idPortalMigrationReducer from './idportalMigrationReducer';

const reducers = combineReducers({
  study: studyReducer,
  login: loginReducer,
  logout: logoutReducer,
  people: peopleReducer,
  routing: routerReducer,
  participants: participantReducer,
  notes: noteReducer,
  modal: modalReducer,
  sponsor: sponsorReducer,
  documents: documentsReducer,
  documentStatus: documentStatusReducer,
  subject: subjectReducer,
  newNote: newNoteReducer,
  participantDetails: participantDetailsReducer,
  helpdesk: helpdeskReducer,
  rolemanagement: assignmentsReducer,
  roles: rolesReducer,
  consentingJournal: consentingJournalReducer,
  monitors: monitorsReducer,
  participantStatus: participantStatusReducer,
  organizations: organizationsReducer,
  reports: reportsReducer,
  menu: menuReducer,
  delegationLog: delegationLogReducer,
  pdf: pdfReducer,
  peopleDetails: peopleDetailsReducer,
  qlikReports: qlikReportsReducer,
  documentStatusSoP: documentStatusSoP,
  changeAnswers: changeAnswersReducer,
  idPortalMigration: idPortalMigrationReducer
});

export default reducers;
